import React, {Component} from 'react';
import './comp-css/main.css';
import Main from './Main';
import Menu from './Menu';
import Footer from './Footer';
import _ from 'lodash';

import ReactDOM from 'react-dom';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  getOffset(element) {
    var bounding = element.getBoundingClientRect();
    return {
      top: bounding.top + document.body.scrollTop,
      left: bounding.left + document.body.scrollLeft
    };

  }

  componentDidMount() {
    window.addEventListener('resize', _.throttle(this.handleResize.bind(this), 100));
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    if(iOSSafari) {
      this.setState({
        'mobileSafari': {
          "background-attachment": "scroll",
          "background-position": "0px, 0px",
          position: "fixed"
        }
      });
    }
    
    this.setState({
      'windowInnerHeight': window.innerHeight
    });
    
    window.addEventListener('scroll', this.handleScroll.bind(this));
    var element = ReactDOM.findDOMNode(this.refs.header);
    var rect = element.getBoundingClientRect();
    var elementNavbar = ReactDOM.findDOMNode(this.refs.navbar);
    var rectNavbar = elementNavbar.getBoundingClientRect();
    var resChange = this.props.resChange;
    resChange(rect.top + rect.height - rectNavbar.height);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  handleResize() {
    let windowsScrollTop = window.pageYOffset;
    let element = ReactDOM.findDOMNode(this.refs.patriksas);
    //var elementSocial = ReactDOM.findDOMNode(this.refs.social);

    let rect = element.getBoundingClientRect();
    //var rectSocial = elementSocial.getBoundingClientRect();

    let topPos = rect.top + 130;
    if(window.innerWidth < 826) {
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.removeProperty("top");
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.clip = "rect(auto, auto, auto, auto)";

      /*  this.setState({
          'psstyles': {}
        }); */
    } else {
      if (windowsScrollTop < 216) {
        let cutLogo = windowsScrollTop - 130;
        //navbar.classList.add("navbar-fixed-top");
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.top = topPos + "px";
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.clip = "rect(auto, auto, " + cutLogo + "px, auto)";
    /*    this.setState({
          'psstyles': {
            top: topPos + "px",
            clip: "rect(auto, auto, " + cutLogo + "px, auto)"
          }
        }); */
      } else {
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.clip = "rect(auto, auto, auto, auto)";
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.top = "-8px";
      /*  this.setState({
          'psstyles': {
            top: "-8px"
          }
        }); */
        //navbar.classList.remove("navbar-fixed-top");
      }
    }
  }

  handleScroll() {
    //var navbar = React.findDOMNode(this.refs.navbar);
    //var startElement = ReactDOM.findDOMNode(this.refs.patriksas);
    //var offset = this.getOffset(startElement)
    //var elementNavbar = ReactDOM.findDOMNode(this.refs.navbar);
    //var rectNavbar = elementNavbar.getBoundingClientRect();

    let windowsScrollTop = window.pageYOffset;
    let element = ReactDOM.findDOMNode(this.refs.patriksas);
    //var elementSocial = ReactDOM.findDOMNode(this.refs.social);

    let rect = element.getBoundingClientRect();
    //var rectSocial = elementSocial.getBoundingClientRect();

    let topPos = rect.top + 130;

    if(window.innerWidth < 825) {
      /*
      if (windowsScrollTop < 196) {
        //navbar.classList.add("navbar-fixed-top");
        let cutLogo = windowsScrollTop - 130;
        this.setState({
          'psstyles': {
            top: topPos + "px",

            clip: "rect(auto, auto, " + cutLogo + "px, auto)"
          }
        });
      } else {
        this.setState({
          'psstyles': {
            top: "12px"
          }
        });
        //navbar.classList.remove("navbar-fixed-top");
      }


        this.setState({
          'psstyles': {}
        });*/
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.removeProperty("top");
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.clip = "rect(auto, auto, auto, auto)";

    } else {

      if (windowsScrollTop < 216) {
        let cutLogo = windowsScrollTop - 130;
        //navbar.classList.add("navbar-fixed-top");

        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.top = topPos + "px";
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.clip = "rect(auto, auto, " + cutLogo + "px, auto)";

        /*
        this.setState({
          'psstyles': {
            top: topPos + "px",
            clip: "rect(auto, auto, " + cutLogo + "px, auto)"
          }
        }); */
      } else {
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.clip = "rect(auto, auto, auto, auto)";
        ReactDOM.findDOMNode(this.refs.patriksasMenu).style.top = "-8px";
        /*
        this.setState({
          'psstyles': {
            top: "-8px"
          }
        }); */
        //navbar.classList.remove("navbar-fixed-top");
      }

    }




    if (windowsScrollTop > 95) {
      //navbar.classList.add("navbar-fixed-top");
      ReactDOM.findDOMNode(this.refs.social).style.top = "4px";
      ReactDOM.findDOMNode(this.refs.social).style.position = "fixed";
      /*
      this.setState({
        'socialstyles': {
          top: "4px",
          position: "fixed"
        }
      }); */
    } else {
      ReactDOM.findDOMNode(this.refs.social).style.removeProperty("top");
      ReactDOM.findDOMNode(this.refs.social).style.removeProperty("position");
      //this.setState({'socialstyles': {}});
    }
  }

  render() {
    return (<div className="App" ref="app">

      <div className="Social" ref="social" style={this.state.socialstyles}>
        <div className="SocialPadF">
          <a href="https://www.facebook.com/PatrikSasOfficial/" target="_blank" rel="noopener noreferrer">
            <div className="SocialPad">
              <i className="fab fa-facebook-f"></i>
            </div>
          </a>
        </div>
        <div className="SocialPadYt">
          <a href="https://www.youtube.com/channel/UCaGj5ycfxmbC0WNu5_L7c3A" target="_blank" rel="noopener noreferrer">
            <div className="SocialPad">
              <i className="fab fa-youtube"></i>
            </div>
          </a>
        </div>
        <div className="SocialPadInsta">
          <a href="https://www.instagram.com/patrik_sas/" target="_blank" rel="noopener noreferrer">
            <div className="SocialPad">
              <i className="fab fa-instagram"></i>
            </div>
          </a>
        </div>
      </div>

      <div className="navbar">

        <Menu ref="navbar" />
        <div className="patriksasMenu" ref="patriksasMenu" style={this.state.psstyles}>PATRIK SAS</div>


      </div>



      
      <div className="footerPadding" >
      <header id="header" className="App-header" ref="header">
        <div className="headerBg" style={this.state.mobileSafari }></div>
          <div className="Wrapper">
            <h1 className="App-title" ref="patriksas">PATRIK SAS</h1>

          </div>
        <div className="Testimonial">
          <div className="TestimonialContent">
          <div className="Testimonial1">&ldquo;
          </div><div className="Testimonial2">
            Patrik is known for his technical and rhythmic heavy precision drumming with extended double-bass blasts
          </div>
          <div className="Testimonial3">
            &ldquo;</div>
          </div>
        </div>
      </header>
        <Main resChange={this.props.resChange} store={this.props.store}/>
      </div>
      <Footer/>
    </div>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js